import React from 'react';

import {getFieldOptions} from 'registry/field/FieldTableOptionGetters';
import FieldTableRow, {FieldTableRowProps} from 'registry/field/FieldTableRow';
import {StorableSchema} from 'samples/storables/StorableSchemaConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

import {TagSchemaSummaryGraphQL} from '../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaSummaryGraphQL';

interface StudySchemaFieldTableRowProps extends Pick<
  FieldTableRowProps,
  'ownerUrlId' | 'id' | 'onCancel' | 'onEdit' | 'requestChange' | 'requestRemove' | 'schemaId'
> {
  initialField: SchemaField;
  schemaFieldSelectors: Array<SchemaFieldSelector>;
  tagSchemas: Array<TagSchemaSummaryGraphQL>;
  storableSchemas: Array<StorableSchema>;
}

export default function StudySchemaFieldTableRow(props: StudySchemaFieldTableRowProps): JSX.Element {
  const availableFieldOptions = getFieldOptions({
    initialField: props.initialField,
    schemaFieldSelectors: props.schemaFieldSelectors,
    storableSchemas: props.storableSchemas,
    assaySchemas: [],
    tagSchemas: props.tagSchemas,
    schemaInterfaces: [],
    includeBooleanField: true,
    includeJSONField: true,
    includeAssayLinks: false,
    includeBatchLinks: false,
    // Studies can already link to entries through Studyable relationships or through the explicit design
    // entry link, so we think allowing a third way of linking to entries is more confusing than helpful.
    includeEntryLinks: false,
    includeSnapshotField: false,
    includeSequenceLinks: false,
    includeDnaSequenceSpecificLinks: false,
    includeProteinLinks: false,
    includeMoleculeLinks: false,
    includeArchivedSchemas: false,
    sequenceSchemaType: null,
  });

  return (
    <FieldTableRow
      {...props}
      availableFieldOptions={availableFieldOptions}
      isUneditable={props.initialField.isUneditable}
    />
  );
}
